/**
 * Sanitize string for JSON-LD to prevent XSS attacks
 * Removes HTML tags and encodes special characters
 */
export const sanitizeString = (str: string | undefined | null): string => {
  if (!str) return ''

  return str
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .trim()
}

/**
 * Safely join strings with a separator, filtering out empty values
 */
export const safeJoin = (
  parts: (string | undefined | null)[],
  separator = ' ',
): string => {
  return parts.filter(Boolean).join(separator)
}

/**
 * Ensure URL is absolute
 */
export const ensureAbsoluteUrl = (
  url: string | undefined | null,
  baseUrl: string,
): string => {
  if (!url) return ''

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }

  return `${baseUrl}${url.startsWith('/') ? '' : '/'}${url}`
}
